module.exports = __webpack_public_path__ + "img/rating.0be2ad66.png";